import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'
import { ListingResponse } from '~in-app/types/api.dto'

import { DistributorListQuery, Distributors } from './types'

export const fetchDistributorList = async (params?: { abortCtrl?: AbortController | AbortSignal, query?: DistributorListQuery }) => {
  return wretchClient
    .url('/admin/1.0/distributors')
    .signal(params?.abortCtrl)
    .query(params?.query || {})
    .get()
    .json<ListingResponse<Distributors>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
export const fetchDistributorDetails = async (params?: { abortCtrl?: AbortController | AbortSignal, id: string }) => {
  return wretchClient
    .url(`/admin/1.0/distributors/${params?.id}`)
    .signal(params?.abortCtrl)
    .get()
    .json<Distributors[]>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const addDistributor = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/distributors`)
    .post(value)
    .json<Distributors>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
export const updateDistributor = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/distributors`)
    .put(value)
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const updateDistributorStatus = async (id: string, activeFlag: string) => {
  return wretchClient
    .url(`/admin/1.0/distributors/${id}/${activeFlag}`)
    .patch()
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const changeDistributorEmail = async (id: string, emailAddr: string) => {
  return wretchClient
    .url(`/admin/1.0/distributors/${id}/emailAddresses/${emailAddr}`)
    .put()
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
